import * as webVitals from 'web-vitals'

import {addActionsToQueue} from './tracking'
import {generateFUSEvent} from './utils'

const PRECISION_MULTIPLIER = 1000

function preparePerformanceMeasure({name, delta, id}: webVitals.Metric) {
  const value = Math.round(name === 'CLS' ? delta * PRECISION_MULTIPLIER : delta)
  const action = generateFUSEvent(
    'PERFORMANCE_MEASURE',
    {
      name,
      value,
      id,
    },
    {
      withContext: true,
    },
  )
  addActionsToQueue([action])
}

function measureWebVitals() {
  webVitals.getLCP(preparePerformanceMeasure, {reportAllChanges: true})
  webVitals.getCLS(preparePerformanceMeasure, {reportAllChanges: true})
  webVitals.getFCP(preparePerformanceMeasure)
  webVitals.getFID(preparePerformanceMeasure)
  webVitals.getTTFB(preparePerformanceMeasure)
}

export default measureWebVitals
